
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/linkapp",
      function () {
        return require("private-next-pages/linkapp/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/linkapp"])
      });
    }
  